import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Paper, Button } from '@material-ui/core';
import {
  disAuthenticate,
  setSystemLodingFLg,
  setInflowType,
  setPasswordPopFlg,
} from '../actions/CommonAction';
import './UserMenu.css';

/**
 * ユーザーメニューコンポーネント
 */
class UserMenu extends Component {
  /**
   * ログアウト処理
   */
  logout = async () => {
    const {
      setSystemLodingFLgAct,
      disAuthenticateAct,
      history,
    } = this.props;
    setSystemLodingFLgAct(true);
    await disAuthenticateAct();
    setSystemLodingFLgAct(false);
    history.push('/login');
  }

  /**
   * パスワード変更POPUP表示処理
   */
  changePassword = () => {
    const {
      setInflowTypeAct,
      setPasswordPopFlgAct,
    } = this.props;
    setInflowTypeAct('2');
    setPasswordPopFlgAct(true);
  }

  render() {
    return (
      <Paper
        elevation={3}
        className="usermenufield"
        style={{ backgroundColor: '#DEF7F5' }}
      >
        <div className="linkfield">
          <Button tabIndex="-1" className="userButton password" onClick={this.changePassword}>
            パスワード変更
          </Button>
          <Button tabIndex="-1" className="userButton logout" onClick={this.logout}>
            ログアウト
          </Button>
        </div>
      </Paper>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    disAuthenticateAct: () => dispatch(disAuthenticate()),
    setSystemLodingFLgAct: (systemLodingFLg) => dispatch(setSystemLodingFLg(systemLodingFLg)),
    setInflowTypeAct: (inflowType) => dispatch(setInflowType(inflowType)),
    setPasswordPopFlgAct: (passwordPopFlg) => dispatch(setPasswordPopFlg(passwordPopFlg)),
  }),
)(withRouter(UserMenu));
